export default {"src":"/org/_next/static/media/alert.07664056.svg","height":16,"width":18,"blurWidth":0,"blurHeight":0};